// extracted by mini-css-extract-plugin
export var attachment = "_rz-a";
export var emailContainer = "_rz-4";
export var emailContentPaddedContainer = "_rz-b";
export var emailHeader = "_rz-6";
export var emailIframe = "_rz-3";
export var emailInfoIcon = "_rz-9";
export var emailShortenedSummary = "_rz-e";
export var infoDropdown = "_rz-0";
export var infoRowBoundedContent = "_rz-d";
export var internal = "_rz-5";
export var merchant = "_rz-8";
export var messageInputContainer = "_rz-h";
export var normal = "_rz-7";
export var replyCard = "_rz-f";
export var subtleButton = "_rz-1";
export var subtleButtonIconContainer = "_rz-2";
export var toggleViewRepliesButton = "_rz-c";
export var wrappingText = "_rz-g";